export const SESSIONS_QUERY_NAMESPACE = ["sessions"] as const;
